import React, { useState, useEffect, useMemo } from "react";
import { Link, useHistory, withRouter } from "react-router-dom";
import { Form, Input, Button, Modal, Checkbox, Space, Typography, Descriptions } from "antd";
import { LeftOutlined } from "@ant-design/icons";
import { lib, event } from "react-single-app";
import md5 from "md5";

import { LoginBg, Send } from "./login/login";
import Privacy from "./privacy";
import ServiceAgreement from "./service-agreement";
import useRootPath from "../components/hook/useRootPath";
import RegisterSuccessModal from "../components/register-success-modal";

function ImgCode() {
    let [url, setUrl] = useState("");

    function getImage() {
        lib.request({
            url: "/ucenter-account/imageCode",
            needMask: false,
            success: res => setUrl(res.data),
        });
    }

    useEffect(function () {
        getImage();
        event.on("refresh-image", getImage);
        return () => event.off("refresh-image");
    }, []);
    return <img className="img-code" src={url} onClick={getImage} width={"95px"} />;
}

function Check({ status = false, children, style = {} }) {
    return (
        <div className={`check ${status}`} style={style}>
            {children}
        </div>
    );
}

function ServiceModal({ modalVisible, onOk }) {
    const [timeCount, timeCountSet] = useState(15);
    useEffect(
        function () {
            let t;
            if (modalVisible) {
                t = setInterval(() => {
                    timeCountSet(timeCount => {
                        if (timeCount > 1) {
                            return timeCount - 1;
                        }
                    });
                }, 1000);
            } else {
                timeCountSet(15);
            }
            return () => {
                clearInterval(t);
            };
        },
        [modalVisible],
    );

    function Footer() {
        return (
            <Space>
                <Button disabled={timeCount > 0} onClick={onOk}>
                    我已知晓{timeCount && `(${timeCount})`}
                </Button>
            </Space>
        );
    }

    return (
        <Modal
            title="服务协议"
            maskClosable={false}
            closable={false}
            visible={modalVisible}
            footer={<Footer />}
            wrapClassName="privacy-modal"
            width={800}>
            <ServiceAgreement inModal={true} />
        </Modal>
    );
}

function PrivacyModal({ modalVisible, onOk }) {
    const [timeCount, timeCountSet] = useState(15);
    useEffect(
        function () {
            let t;
            if (modalVisible) {
                t = setInterval(() => {
                    timeCountSet(timeCount => {
                        if (timeCount > 1) {
                            return timeCount - 1;
                        }
                    });
                }, 1000);
            } else {
                timeCountSet(15);
            }
            return () => {
                clearInterval(t);
            };
        },
        [modalVisible],
    );

    function Footer() {
        return (
            <Space>
                <Button disabled={timeCount > 0} onClick={onOk}>
                    我已知晓{timeCount && `(${timeCount})`}
                </Button>
            </Space>
        );
    }

    return (
        <Modal
            title="隐私条款"
            maskClosable={false}
            closable={false}
            visible={modalVisible}
            footer={<Footer />}
            wrapClassName="privacy-modal"
            width={800}>
            <Privacy inModal={true} />
        </Modal>
    );
}

function Register() {
    let history = useHistory();
    let [mobile, setMobile] = useState("");
    let [imgCode, setImgCode] = useState("");
    let [password, setPassword] = useState("");
    let [modalVisible, modalVisibleSet] = useState(false);
    let [serviceVisible, serviceVisibleSet] = useState(false);
    let [registerSuccessModalVisible, setRegisterSuccessModalVisible] = useState(false);
    const [echo, setEcho] = useState();
    const [phoneExist, setPhoneExist] = useState(false);
    const [form] = Form.useForm();
    const rootPath = useRootPath();
    let type = lib.getParam("type");
    let userRegisterCompany = type == 2;
    /**
     * 员工注册子账号 来着邀请链接
     * @type {false|string|number}
     */
    let userRegisterFromInvite = type == 3 && !!lib.getParam("join");
    let title = "邀请您注册小二后台";
    //商家端
    if (lib.config.webToken === "user") {
        if (type == 2) {
            title = "创建全新的企业或组织";
        } else {
            if (userRegisterFromInvite) {
                title = `${lib.getParam("name")}邀请您加入企业`;
            } else {
                title = "创建员工子帐号";
            }
        }
    }

    function showPrivacyCheck() {
        const confirm = Modal.confirm({
            title: "提示",
            content: (
                <span>
                    <span style={{ color: "rgba(0, 0, 0, 0.45)" }}>我已阅读并同意</span>
                    <a href={`${rootPath}/privacy`} target={"_blank"}>
                        《隐私条款》
                    </a>
                    和
                    <a href={`${rootPath}/service-agreement`} target={"_blank"}>
                        《服务协议》
                    </a>
                </span>
            ),
            onOk: e => {
                confirm.destroy();
                privacyClick();
            },
        });
    }

    function register(formData) {
        if (!formData.privacy) {
            showPrivacyCheck();
            return;
        }
        let url = "/ucenter-account/user/customer/register";
        if (lib.config.webToken == "admin") {
            url = "/ucenter-account/user/admin/register";
            formData.inviteCode = lib.getParam("inviteCode");
        } else {
            if (userRegisterFromInvite) {
                formData.masterUserId = lib.getParam("join");
                if (phoneExist) {
                    formData.userId = echo?.userId;
                    delete formData.userName;
                    delete formData.nickName;
                }
            }
            formData.type = type;
        }
        delete formData.privacy;
        if (formData.password) {
            formData.password = md5(formData.password);
            formData.passwordRepeat = md5(formData.passwordRepeat);
        }
        const data = {
            ...formData,
            isEncrypt: true,
        };

        lib.request({
            url,
            needMask: true,
            data,
            success: json => {
                //注册子账号且手机号没注册过弹框
                if (type == 3 && !phoneExist) {
                    setRegisterSuccessModalVisible(true);
                } else {
                    Modal.success({
                        content: json.message,
                        onOk: () => history.push(`${rootPath}/login`),
                    });
                }
            },
        });
    }

    function serviceOk() {
        form.setFieldsValue({ privacy: true });
        serviceVisibleSet(false);
    }

    function privacyOk() {
        modalVisibleSet(false);
        serviceVisibleSet(true);
    }

    function privacyClick(e) {
        if (form.getFieldValue("privacy")) {
            return;
        }
        modalVisibleSet(true);
        form.setFieldsValue({ privacy: null });
        e?.preventDefault();
    }

    function getSubmitText() {
        let text;
        if (lib.config.webToken == "admin") {
            text = "创建帐户";
        } else {
            if (userRegisterCompany) {
                text = "立即创建企业";
            } else if (userRegisterFromInvite) {
                text = "加入企业";
            } else {
                text = "创建帐户";
            }
        }
        return text;
    }

    function checkPhoneExist() {
        const { code, mobile } = form.getFieldsValue();
        if (type == 3 && code && mobile) {
            lib.request(
                {
                    url: "/ucenter-customer/user/sub/echo",
                    needMask: false,
                    data: { code, mobile },
                    success: res => {
                        setEcho(res);
                        form.setFieldsValue(res);
                        if (res) {
                            setPhoneExist(true);
                            Modal.info({
                                title: "提示",
                                content: (
                                    <span>
                                        您已创建员工帐户，点击【加入企业】即可加入
                                        <span className={"link"}>{lib.getParam("name")}</span>
                                    </span>
                                ),
                                okText: "我知道了",
                            });
                        }
                    },
                },
                false,
            );
        }
    }

    const getRegisterSuccessInfo = useMemo(() => {
        return form.getFieldsValue();
    }, [registerSuccessModalVisible]);
    return (
        <>
            <LoginBg />
            <div className={"register-container"}>
                <div className={"pin"}>
                    <div className={"pin-circle"}></div>
                    <span className={"arrow"}></span>
                </div>
                <div className={"wrapper"}>
                    <Link to={`${rootPath}/login`} className={"back"}>
                        <LeftOutlined />
                        返回
                    </Link>
                    <Typography.Title className="title" level={4}>
                        {title}
                    </Typography.Title>
                    <Form
                        form={form}
                        className={"register-form"}
                        name="type1"
                        onFinish={data => register(data)}
                        layout={"vertical"}
                        autoComplete={"off"}>
                        <Typography.Title level={5}>
                            {userRegisterCompany ? "企业信息" : "联系人信息"}{" "}
                        </Typography.Title>
                        {userRegisterCompany && (
                            <Form.Item
                                name="userName"
                                label={"企业用户名"}
                                rules={[
                                    { required: true, message: "请输入用户名" },
                                    {
                                        pattern: /[\w\W]{3,20}/,
                                        message:
                                            "企业用户名为3-20位的字母、数字、中文、特殊符号的组合",
                                        validateTrigger: "onBlur",
                                    },
                                ]}>
                                <Input placeholder="推荐使用企业名称" />
                            </Form.Item>
                        )}

                        <Form.Item
                            name="mobile"
                            label={"手机号"}
                            rules={[
                                {
                                    required: true,
                                    message: "请输入手机号",
                                },
                                {
                                    pattern: /^\d{0,11}$/,
                                    message: "手机号码为1开头的11位数字",
                                    validateTrigger: "onChange",
                                },
                                {
                                    pattern: /^1\d{10}$/,
                                    message: "手机号码为1开头的11位数字",
                                    validateTrigger: "onBlur",
                                },
                            ]}>
                            <Input
                                placeholder="请输入手机号"
                                onChange={e => setMobile(e.target.value)}
                                maxLength={11}
                            />
                        </Form.Item>
                        <Form.Item required={true} label={"图形验证码"}>
                            <div className="code">
                                <Form.Item
                                    name="imgCode"
                                    noStyle
                                    rules={[{ required: true, message: "请输入图形验证码" }]}>
                                    <Input
                                        maxLength={6}
                                        onChange={e => setImgCode(e.target.value)}
                                        placeholder="请输入图形验证码"
                                    />
                                </Form.Item>
                                <ImgCode />
                            </div>
                        </Form.Item>
                        <Form.Item required={true} label={"手机验证码"}>
                            <div className="code">
                                <Form.Item
                                    name="code"
                                    noStyle
                                    rules={[
                                        {
                                            required: true,
                                            message: "请输入手机验证码",
                                        },
                                        {
                                            pattern: /^\d{0,6}$/,
                                            message: "手机验证码格式错误",
                                        },
                                    ]}>
                                    <Input
                                        placeholder="请输入手机验证码"
                                        onBlur={checkPhoneExist}
                                    />
                                </Form.Item>
                                <Send
                                    data={{
                                        code: imgCode,
                                        mobile,
                                        type: userRegisterFromInvite
                                            ? "INVITE_REGISTER"
                                            : "REGISTER",
                                    }}
                                    size={"middle"}
                                />
                            </div>
                        </Form.Item>

                        <Form.Item
                            name="email"
                            label={"邮箱（可选）"}
                            rules={[
                                {
                                    type: "email",
                                    message: "邮箱格式不对，例xxx@163.com",
                                    validateTrigger: "onBlur",
                                },
                            ]}>
                            <Input
                                placeholder={phoneExist ? "" : "请输入有效邮箱"}
                                disabled={phoneExist}
                            />
                        </Form.Item>
                        <Typography.Title level={5}>
                            {userRegisterCompany ? "设置密码" : "帐号设置密码"}
                        </Typography.Title>
                        {!userRegisterCompany && (
                            <Form.Item
                                name="userName"
                                label={"用户名"}
                                validateTrigger={["onBlur", "onChange"]}
                                rules={[
                                    {
                                        required: true,
                                        message: "请输入用户名",
                                        validateTrigger: "onChange",
                                    },
                                    {
                                        pattern: /[\w\W]{3,20}/,
                                        message: "用户名为3-20位的字母、数字、中文、特殊符号的组合",
                                        validateTrigger: "onBlur",
                                    },
                                ]}>
                                <Input
                                    placeholder={phoneExist ? "" : "请输入用户名"}
                                    disabled={phoneExist}
                                />
                            </Form.Item>
                        )}
                        {(lib.config.webToken == "admin" || !userRegisterCompany) && (
                            <Form.Item
                                label={"姓名"}
                                name="nickName"
                                rules={[
                                    {
                                        pattern: /[\w\W]{0,50}/,
                                        message: "姓名是0-50位的字母、数字、中文、特殊符号的组合",
                                    },
                                ]}>
                                <Input
                                    placeholder={phoneExist ? "" : "请输入姓名"}
                                    disabled={phoneExist}
                                />
                            </Form.Item>
                        )}
                        {!phoneExist && (
                            <>
                                <Form.Item
                                    label={"密码"}
                                    name="password"
                                    validateTrigger={["onSubmit"]}
                                    rules={[
                                        {
                                            required: true,
                                            message: "请输入密码",
                                            validateTrigger: "onChange",
                                        },
                                        {
                                            validator: (rule, value) => {
                                                return new Promise((resolve, reject) => {
                                                    if (
                                                        !/^([\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]|\w){8,20}$/.test(
                                                            value,
                                                        ) ||
                                                        /[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]+/.test(
                                                            value,
                                                        ) +
                                                            /\d+/.test(value) +
                                                            /[a-z]+/.test(value) +
                                                            /[A-Z]+/.test(value) <
                                                            3
                                                    ) {
                                                        reject();
                                                    } else {
                                                        resolve();
                                                    }
                                                });
                                            },
                                            validateTrigger: "onSubmit",
                                        },
                                    ]}>
                                    <Input.Password
                                        placeholder="密码"
                                        autoComplete={"new-password"}
                                        maxLength={20}
                                        onChange={e => setPassword(e.target.value)}
                                    />
                                </Form.Item>

                                <Check
                                    style={
                                        !form.getFieldError("password")
                                            ? { marginTop: "-15px" }
                                            : {}
                                    }
                                    status={(() => {
                                        return password.length > 7 && password.length < 21;
                                    })()}>
                                    密码长度为8-20位
                                </Check>
                                <Check
                                    status={(function () {
                                        return /^([\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]|\w)+$/.test(
                                            password,
                                        );
                                    })()}>
                                    只能包含大小写字母、数字以及英文符号（不含空格）
                                </Check>
                                <Check
                                    style={{ marginBottom: "10px" }}
                                    status={(function () {
                                        return (
                                            /[\x21-\x2f\x3a-\x40\x5b-\x60\x7B-\x7F]+/.test(
                                                password,
                                            ) +
                                                /\d+/.test(password) +
                                                /[a-z]+/.test(password) +
                                                /[A-Z]+/.test(password) >
                                            2
                                        );
                                    })()}>
                                    大写字母、小写字母、数字和英文符号至少包含3种
                                </Check>
                                <Form.Item
                                    label={"重复密码"}
                                    name="passwordRepeat"
                                    validateTrigger={["onBlur", "onChange"]}
                                    rules={[
                                        {
                                            required: true,
                                            message: "请输入重复密码",
                                            validateTrigger: "onChange",
                                        },
                                        ({ getFieldValue }) => ({
                                            validator(rule, value) {
                                                if (!value || getFieldValue("password") === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject("密码不一致!");
                                            },
                                            validateTrigger: "onBlur",
                                        }),
                                    ]}>
                                    <Input.Password placeholder="重复密码" />
                                </Form.Item>
                            </>
                        )}
                        <Form.Item name="privacy" valuePropName="checked">
                            <Checkbox onClick={privacyClick}>
                                <span style={{ color: "rgba(0, 0, 0, 0.45)" }}>我已阅读并同意</span>
                                <Link to={`${rootPath}/privacy`} target={"_blank"}>
                                    《隐私条款》
                                </Link>
                                和
                                <Link to={`${rootPath}/service-agreement`} target={"_blank"}>
                                    《服务协议》
                                </Link>
                            </Checkbox>
                        </Form.Item>
                        <div className={"register-submit"}>
                            <Button type="primary" htmlType="submit">
                                {getSubmitText()}
                            </Button>
                        </div>
                    </Form>
                </div>
            </div>
            <PrivacyModal {...{ modalVisible, onOk: privacyOk }} />
            <ServiceModal {...{ modalVisible: serviceVisible, onOk: serviceOk }} />
            <RegisterSuccessModal
                info={getRegisterSuccessInfo}
                visible={registerSuccessModalVisible}
                onClose={() => {
                    setRegisterSuccessModalVisible(false);
                    history.push(`${rootPath}/login`);
                }}
            />
        </>
    );
}

export default Register;
